function handleError(response, history) {
  console.log("handleError", response);

  if (!response) {
    if (process.env.NODE_ENV === "development") {//toast.error(`Error: ${response}`, { toastId: customId });
    }

    return;
  }

  if (response) {
    const {
      status,
      message
    } = response;

    if (status === 401 || status === 408) {
      localStorage.removeItem("fiver_react_access_token");
      localStorage.removeItem("fiver_react_refresh_token");

      if (history) {
        history.push("/");
      }
    } else {
      if (process.env.NODE_ENV === "development") {//toast.error(`Error: code ${status} message ${message}`);
      }
    }
  }
}

export default handleError;